import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const LegacyHmsComparison = () => {
  return (
    <section id="legacy-vs-modern" className="landing legacy-landing">
      <Helmet>
        <title>Modernize Your Hospital: Cloud HMS vs. Legacy Software — Analysis</title>
        <meta name="description" content="Are you still running slow, on-premise legacy hospital software? Compare the cost and performance of upgrading to modern Cloud HMS systems in India." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/compare/mediway-vs-legacy-hms" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            'name': 'Mediway Nextgen Cloud vs Legacy HMS Systems Comparison',
            'description': 'Direct comparative analysis illustrating IT cost savings and administrative speed gains achieved by moving from on-premise systems to Cloud HIS.',
            'publisher': {
              '@type': 'Organization',
              'name': 'Wayug Infotech Solutions Limited'
            }
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">Ditch Slow Legacy Systems for Modern Cloud HMS</h2>
          <p className="section-subtitle">Stop paying massive local server maintenance fees and experiencing painful system crashes. Experience instantaneous speed and security.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">⚡</div>
            <div className="service-info">
              <h3 className="service-title">Upgrading Your Infrastructure</h3>
              <p className="service-description">Modern cloud healthcare suites offer automated backups, remote access on mobile, and zero local hardware failures—features old server-room setups simply cannot match.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Cloud Advantage Checklist</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>Access from anywhere (Doctors on mobile)</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Zero server crash downtime risk</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Automatic real-time compliance updates</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Drastically lower upfront setup cost</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Transitioning Gains</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">📊</div><span>70% Lower IT cost</span></div>
                <div className="benefit-card"><div className="benefit-icon">💨</div><span>100x Quicker load time</span></div>
                <div className="benefit-card"><div className="benefit-icon">🔄</div><span>Safe data migration</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Schedule Free Migration</Link>
            <Link to="/about" className="btn btn-secondary">Learn About Us</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default LegacyHmsComparison;
